module.exports = __webpack_public_path__ + "media/src/web/images/home/heroimg_bg-9511fafd3bc0dd32e13823d5126d3dd2.jpg";